import { Heart } from 'lucide-react'
import type { BlockProps } from '../types.js'
import { formatParentNames } from './formatters.js'

interface HeroBlockProps extends BlockProps {
  layout?: 'centered' | 'fullbleed'
  /** 템플릿 고유 CSS 모듈 */
  css: Record<string, string>
}

export function HeroBlock({ invitation, css }: HeroBlockProps) {
  const groomName = invitation.groom?.name || '신랑'
  const brideName = invitation.bride?.name || '신부'
  const groomRelation = invitation.groom?.relation || '아들'
  const brideRelation = invitation.bride?.relation || '딸'
  const coverImage = invitation.gallery?.coverImage || invitation.aiPhotoUrl
  const groomParents = formatParentNames(invitation.groom)
  const brideParents = formatParentNames(invitation.bride)

  return (
    <div className={css.hero}>
      {coverImage && (
        <img src={coverImage} alt="" className={css.heroImage} />
      )}
      <div className={css.heroOverlay} />
      <div className={css.heroContent}>
        <div className={css.coupleNames}>
          {groomName} <Heart size={12} style={{ display: 'inline', verticalAlign: 'middle', color: 'var(--ds-color-primary)' }} /> {brideName}
        </div>
        {(groomParents || brideParents) && (
          <div className={css.parentNames}>
            {groomParents && <span>{groomParents}의 {groomRelation} {groomName}</span>}
            {groomParents && brideParents && <span className={css.parentSep} />}
            {brideParents && <span>{brideParents}의 {brideRelation} {brideName}</span>}
          </div>
        )}
        <div className={css.heroSub}>결혼합니다</div>
      </div>
    </div>
  )
}
